export default {
  W: {
    to: {
      kW: (W) => Math.floor(W / 1000),
    },
  },
}
